import * as React from "react";
import { Tooltip } from "antd";
import { AlertCircle } from "react-feather";

export function renderEventWarningIcon(hasWarning: boolean): (() => React.ReactNode) | undefined {
  if (!hasWarning) return undefined;
  return () => (
    <span className="absolute right-0 top-0 bottom-0 flex items-center justify-center pr-2">
      <Tooltip title="Recent error event">
        <AlertCircle size={16} className="color-danger" />
      </Tooltip>
    </span>
  );
}
